/**
 * Shared optimistic-overlay helper for associate self-attestation checklists
 * (Legacy360PreAppointmentChecklist, Share360NextStepsChecklist). Both read
 * their checked state from a parent-supplied lead snapshot (the trpc.lead.list
 * cache) rather than fetching their own data, so without an overlay a click
 * doesn't visibly update until that cache is invalidated and refetched. This
 * merges a pending/just-confirmed local override on top of the last known
 * server state so a click shows its new value immediately; callers clear the
 * override once the authoritative refetch has landed (success) or immediately
 * (error, so a failed save never keeps showing a value that was never saved).
 */
export function withOptimisticOverride<T extends Record<string, boolean>>(
  serverState: Partial<T> | null | undefined,
  optimistic: Partial<T> | null | undefined,
): Partial<T> {
  return (optimistic ? { ...(serverState ?? {}), ...optimistic } : { ...(serverState ?? {}) }) as Partial<T>;
}
